import { Component, OnInit } from '@angular/core';
import { ScreenManagerService } from '@mpt-fo/common/core/services/screen-manager.service';

@Component({
	selector: 'app-pin-get-started',
	templateUrl: './pin-get-started.component.html',
	styleUrls: ['./pin-get-started.component.scss']
})
export class PinGetStartedComponent implements OnInit {

	isMobile: any = false;
	constructor(private screenManagerService: ScreenManagerService) { }


	ngOnInit(): void {
		this.isMobile = this.screenManagerService.isMobile();
		this.screenManagerService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
	}

}
